<template>
  <div class="tariff-desc">
    <h3 class="desc-title">{{ __('website.tariffs.h3.more_tariffs') }}</h3>
    <div
      class="tariff-table"
      :class="{ expanded }"
    >
      <div
        v-for="(block, index_1) in tableData"
        :key="index_1"
        class="tariff-block"
      >
        <div class="row head-row">
          <div>{{ block.title }}</div>
          <div
            v-for="(tariff, index_2) in tariffTypes"
            :key="index_2"
          >{{ tariff }}</div>
        </div>
        <div
          v-for="(item, index_3) in block.scope"
          class="row"
          :key="index_3"
        >
          <div>{{ item }}</div>
          <div>
              <template v-if="block.allIncludedFlag"><CheckIcon /></template>
              <template v-else>&mdash;</template>
          </div>
          <div>
              <template v-if="block.recruitingFlag"><CheckIcon /></template>
              <template v-else>&mdash;</template>
          </div>
          <div>
              <template v-if="block.hrFlag"><CheckIcon /></template>
              <template v-else>&mdash;</template>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!expanded"
      class="expand-control"
    >
      <ExpandButton @click="expandTable" />
    </div>
    <div
      v-else
      class="book-demo"
    >
      <CustomBtn
        v-if="showBookingBtn"
        @click="openDemoModal"
      >{{ __('website.tariffs.cta.book_demo') }}</CustomBtn>
    </div>
  </div>
</template>

<script>
import { openDemoModal } from '@/utils';

import CheckIcon from '@/components/icons/CheckIcon';
import CustomBtn from '@/components/CustomBtn';

import ExpandButton from './ExpandButton';

export default {
  name: 'TariffDesc',

  components: {
    CheckIcon,
    ExpandButton,
    CustomBtn,
  },

  data() {
    return {
      expanded: false,
      showBookingBtn: false,
    };
  },

  methods: {
    openDemoModal,

    expandTable() {
      this.expanded = true;
      setTimeout(() => (this.showBookingBtn = true), 500);
    }
  },

  computed: {
    tariffTypes() {
      return [
        this.__('website.tariffs.all-in-one.header'),
        this.__('website.tariffs.recruiting.header'),
        this.__('website.tariffs.hr.header'),
      ];
    },
    tableData() {
      return {
        basic: {
          title: this.__('website.tariffs.basic_functionality'),
          scope: [
            this.__('website.tariffs.basic_functionality_1'),
            this.__('website.tariffs.basic_functionality_2'),
            this.__('website.tariffs.basic_functionality_3'),
            this.__('website.tariffs.basic_functionality_4'),
            this.__('website.tariffs.basic_functionality_5'),
            this.__('website.tariffs.basic_functionality_6'),
          ],
          allIncludedFlag: true,
          recruitingFlag: true,
          hrFlag: true,
        },
        recruiting: {
          title: this.__('website.tariffs.recruiting.header'),
          scope: [
            this.__('website.tariffs.recruiting_1'),
            this.__('website.tariffs.recruiting_2'),
            this.__('website.tariffs.recruiting_3'),
            this.__('website.tariffs.recruiting_4'),
            this.__('website.tariffs.recruiting_5'),
            this.__('website.tariffs.recruiting_6'),
            this.__('website.tariffs.recruiting_7'),
            this.__('website.tariffs.recruiting_8'),
            this.__('website.tariffs.recruiting_9'),
            this.__('website.tariffs.recruiting_10'),
            this.__('website.tariffs.recruiting_11'),
          ],
          allIncludedFlag: true,
          recruitingFlag: true,
          hrFlag: false,
        },
        hr: {
          title: this.__('website.tariffs.hr.header'),
          scope: [
            this.__('website.tariffs.hr_1'),
            this.__('website.tariffs.hr_2'),
            this.__('website.tariffs.hr_3'),
            this.__('website.tariffs.hr_4'),
            this.__('website.tariffs.hr_5'),
            this.__('website.tariffs.hr_6'),
            this.__('website.tariffs.hr_7'),
            this.__('website.tariffs.hr_8'),
            this.__('website.tariffs.hr_9'),
            this.__('website.tariffs.hr_10'),
          ],
          allIncludedFlag: true,
          recruitingFlag: false,
          hrFlag: true,
        }
      };
    },
  },
};
</script>

<style lang="sass" scoped>
.tariff-desc
  color: #fff
  max-width: 1135px
  margin: 0 auto
  color: #BCC4D2
  font-size: 15px
  line-height: 22px
.tariff-table
  max-height: 334px
  overflow: hidden
  position: relative
  transition: max-height 1.5s
  &:before
    position: absolute
    top: 0
    bottom: 0
    right: 0
    left: 0
    content: ''
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #292F42 100%)
    pointer-events: none
  &.expanded
    max-height: 9999px
    &:before
      display: none
.tariff-block:first-of-type
  .row:first-child
      div:nth-child(2)
        border-radius: 20px 20px 0 0
.desc-title
  font-size: 22px
  line-height: 32px
  color: #fff
  margin: 40px 0 24px
  text-align: center
.row
  display: flex
  border-bottom: 1px solid #444A62
  &.head-row
    color: #fff
    font-weight: 600
    border-bottom-color: #BCC4D2
  div
    display: flex
    justify-content: center
    align-items: center
    padding: 12px 0 13px
    &:nth-child(1)
      flex-grow: 1
      justify-content: flex-start
      max-width: calc(100% - 480px)
      padding: 12px 5px 13px 0
    &:nth-child(2)
      width: 170px
      background-color: rgba(59, 67, 97, 0.42)
    &:nth-child(3)
      width: 170px
    &:nth-child(4)
      width: 140px
.expand-control,
.book-demo
  display: flex
  justify-content: center
  width: 100%
.expand-control
  margin: -32px 0 0
.book-demo
  margin: 56px 0 0

@media screen and (max-width: 999px)
  .row
    div
      &:nth-child(1)
        max-width: calc(100% - 328px)
      &:nth-child(2)
        width: 119px
      &:nth-child(3)
        width: 119px
      &:nth-child(4)
        width: 90px
  .book-demo
    margin: 40px 0 0

@media screen and (max-width: 599px)
  .tariff-desc
    display: none
</style>